import React from "react";
import { Icon } from "@iconify/react";

const StarRating = ({ rating }) => {
  const stars = Array.from({ length: 5 }, (_, index) => {
    const isFilled = index < Math.floor(parseFloat(rating));
    // const isHalfFilled = index === Math.floor(rating) && rating % 1 !== 0;
    const isHalfFilled = false;

    return (
      <span key={index} className="star">
        {isFilled ? (
          <Icon icon="solar:star-bold" style={{ color: "gold" }} />
        ) : isHalfFilled ? (
          <span className="half-star">
            <Icon
              icon="solar:star-bold"
              style={{
                color: "gold",
                position: "absolute",
                clipPath: "inset(0 50% 0 0)",
              }}
            />
            <Icon
              icon="solar:star-bold"
              style={{
                color: "#C3C3C3",
                position: "absolute",
                clipPath: "inset(0 0 0 50%)",
              }}
            />
          </span>
        ) : (
          <Icon icon="solar:star-bold" style={{ color: "#C3C3C3" }} />
        )}
      </span>
    );
  });

  return <div className="star-rating">{stars}</div>;
};

export default StarRating;
